const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight-addon" */ '@/pages/financial/tariff/freight/addon/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight-addon" */ '@/pages/financial/tariff/freight/addon/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight-addon" */ '@/pages/financial/tariff/freight/addon/edit.vue'
  )

export default {
  name: 'FinancialFreightAddonTariff',
  path: 'addon',
  meta: {
    label: 'addon',
    auth: 'addon'
  },
  component: {
    name: 'Addon',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialFreightTariffAddonReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialFreightCreateTariffAddon',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialFreightEditTariffAddon',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
